import { render, staticRenderFns } from "./PlotChange.vue?vue&type=template&id=2c022066&scoped=true"
import script from "./PlotChange.vue?vue&type=script&lang=ts"
export * from "./PlotChange.vue?vue&type=script&lang=ts"
import style0 from "./PlotChange.vue?vue&type=style&index=0&id=2c022066&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c022066",
  null
  
)

export default component.exports